export default {
  zh: {
    email: '邮件',
    password: '密码',
    forgetPassword: '忘记密码',
    zh: '中文',
    en: '英文',
    login: '登录',
    loginToSandbox: '登录到LogixCRM',
    forgotPassword: '忘记密码',
    enterPassWordTip: '请输入您需要找回登录密码的邮箱',
    nextStep: '下一步',
    backToLogin: '记得密码? ',
    checkEmail: '查看邮箱',
    back: '返回登录',
    checkEmailToReset: {
      firstParagraph: '重新设置密码的链接已经成功发送到您的邮箱，请查看您的邮箱。',
      secondParagraph: '如果您无法找到此电子邮件，请与您的管理员联系并确认您的电子邮件地址是正确的。'
    },
    resetPassword: '重置密码',
    requestedToReset: '您正在修改此账号的密码：',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    submitBtn: '确认',
    confirmPasswordError: '请确认两次密码输入相同',
    passwordHasbeenReset: '您的密码已重置',
    hi: '您好 {username}，',
    firstContent: '您的密码已成功重置，请点击下面的链接返回登录页面',
    secondContent: '如果您不知道为什么收到这份邮件，请联系LOGIX CRM。',
    inputEmail: '请输入注册电子邮件地址',
    inputPassword: '请输入密码',
    verificationTitle: '安全验证',
    verificationText: '为确保您的帐户安全，请完成以下验证',
    verificationSupport: '无法收到安全验证码？请联系',
    enterVerificationCode: '请输入验证码……'
  },
  en: {
    email: 'Email',
    password: 'Password',
    forgetPassword: 'Forgot Password',
    zh: 'Chinese',
    en: 'English',
    login: 'Login',
    loginToSandbox: 'Log in',
    forgotPassword: 'Forgot Password',
    enterPassWordTip: 'Enter your Email to help us identify you',
    nextStep: 'Next Step',
    backToLogin: 'Remembered? ',
    checkEmail: 'Check your Email',
    back: 'Back',
    checkEmailToReset: {
      firstParagraph: 'Please check your email for instructions on how to reset your password.',
      secondParagraph: 'If you can’t locate this email, check with your administrator to confirm that they have your correct email address on file.'
    },
    resetPassword: 'Reset Password',
    requestedToReset: 'You have requested to change the password for:',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    submitBtn: 'Submit',
    confirmPasswordError: 'Please confirm the password as same as above',
    passwordHasbeenReset: 'YOUR PASSWORD HAS BEEN RESET',
    hi: 'Hi {username},',
    firstContent: 'Your password has been successfully reset, and please click the button below to the login page.',
    secondContent: 'Please contact the LOGIX CRM Service Centre on 13 69 37 if you did not make this request',
    inputEmail: 'Please input your Email!',
    inputPassword: 'Please input your Password!',
    verificationTitle: 'Security verification',
    verificationText: 'To keep your account secure, please complete the following verification',
    verificationSupport: 'Security verification unavailable? Please contact',
    enterVerificationCode: 'Enter your verification code...'
  },
};



// WEBPACK FOOTER //
// ./src/views/Auth/i18n.js